import React, { Component } from 'react'
import graphql from 'babel-plugin-relay/macro'
import { QueryRenderer } from "react-relay";

import Row from '../../components/row'
import environment from '../../environment'
import searchIcon from '../../images/search_1.svg'

import Article from '../home-page/article'

class SearchPage extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            searchTerm: this.props.searchTerm,
        }

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event)
    {
        this.setState({searchTerm: event.target.value})
    }

    render() {
        const {
            loading, searchTerm, orderByRelevance, onOrderByRelevance, orderByLatest,
            onOrderByLatest, cityFilter, onCityFilter, categoryFilter, onCategoryFilter, articles
        } = this.props
        console.log('unesed', searchTerm)
        const rows = articles.length ? Math.ceil(articles.length / 4.0) : 0
        
        return (
            <div style={{"minHeight":"63vh"}} >
                <div className="div-block-100" style={{"paddingBottom":"0px"}} >
                    <div className="div-block-111">
                        <div className="div-block-105" style={{"alignItems":"baseline"}}>
                            <h1 className="heading-23 search-input-3">Results for</h1>
                            <div className="text-block-96">
                                <form action="/search" className="search-2 nav-search-form" >
                                    <input type="text" value={this.state.searchTerm} autoComplete="off" name="query" onChange={this.handleChange} className="result-input" />
                                    <div className="div-block-94">
                                        <button type="submit" className="search-button-2 w-button">
                                            <img alt="" src={searchIcon} style={{"marginLeft":"0px"}} width={18} className="nav-icon" />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {!loading &&
                            <div className="numberofarticles">
                                {articles.length} articles found
                            </div>
                        }
                    </div>
                </div>
                <div className="div-block-96">
                    <div data-w-id="af954ee3-333e-1b31-656e-0882d13cc925" className="div-block-118 w-hidden-main w-hidden-medium">
                        <div data-w-id="cac3b989-d2b5-18a7-5c8b-23ba270f2d73" className="show">SHOW&nbsp;FILTERS</div>
                        <div data-w-id="9943f2e3-9f41-1caf-4aca-e45b38fcf70b" className="text-block-hide">HIDE&nbsp;FILTERS</div>
                    </div>
                    <div data-w-id="3bd58403-213f-46fe-cd4b-82a71dd3cc07" className="div-block-101">
                        <div className="div-block-112">
                            <div className="div-block-103">
                                <div className="text-block-94">Sort by:</div>
                                <a
                                    
                                    className={`text-block-95 ${orderByRelevance ? 'selected' : ''}`}
                                    onClick={onOrderByRelevance}
                                >
                                    Relevance
                                </a>
                                <a
                                    
                                    className={`text-block-95 ${orderByLatest ? 'selected' : ''}`}
                                    onClick={onOrderByLatest}
                                >
                                    Latest to oldest
                                </a>
                            </div>
                            <div className="div-block-104">
                                <div className="text-block-94">Filter:</div>
                                <a
                                    
                                    className={`text-block-95 ${cityFilter ? 'selected': ''}`}
                                    onClick={onCityFilter}
                                >
                                    City
                                </a>
                                <a
                                    
                                    className={`text-block-95 ${categoryFilter ? 'selected': ''}`}
                                    onClick={onCategoryFilter}
                                >
                                    Playbook
                                </a>
                            </div>
                        </div>
                        <div className="div-block-search">
                            <div className="text-block-94">Keep searching</div>
                            <img alt="" src="images/search_1.svg" data-w-id="87d2a564-a59e-1531-b784-e5ef86d94c23" className="nav-icon" />
                        </div>
                    </div>
                    {Array(rows).fill().map((_, r) =>
                        <Row key={r} size="15">
                            {articles.slice(r * 4, r * 4 + 4).map((a, k) =>
                                <Article key={k} small {...a} />
                            )}
                        </Row>
                    )}
                </div>
                {/*TODO: Implement pagination
                <div className="page-count">
                    <div className="div-block-113"><a  className="link-block-15 w-inline-block"><img alt="" src="images/ARROW-F.svg" width={10} className="image-103 left" /><div className="text-block-99">PREV</div></a>
                        <div className="div-block-114"><a  className="link-17">1</a><a  className="link-17 selected">2</a><a  className="link-17">3</a></div>
                        <a  className="link-block-15 w-inline-block">
                            <div className="text-block-99">NEXT</div><img alt="" src="images/ARROW-F.svg" width={10} className="image-103" /></a>
                    </div>
                </div>*/}
            </div>
        )
    }
}

class SearchContainer extends Component {

    constructor() {
        super()
        this.state = {
            searchTerm: '',
            orderByRelevance: true,
            orderByLatest: false,
            cityFilter: true,
            categoryFilter: true,
        }
    }

    componentWillMount() {
        this.setState({ searchTerm: this.props.location.query.query })
    }

    render() {
        const { routeResolver } = this.props.context
        return (
            <QueryRenderer
                environment={environment}
                query={graphql`
                    query searchPageQuery($searchTerm: String, $orderBy: ArticleOrdering) {
                        articles(searchTerm: $searchTerm, orderBy: $orderBy) {
                            slug
                            title
                            caption
                            readingTime
                            picture
                            author {
                                firstname
                                lastname
                            }
                            city {
                                slug
                                name
                                color
                            }
                            category {
                                slug
                                name
                                color
                            }
                        }
                    }
                `}
                variables={{
                    searchTerm: this.state.searchTerm,
                    orderBy: this.state.orderByRelevance ? 'relevancy_DESC' : 'publishedAt_DESC',
                }}
                render={({error, props}) => {
                    // if (error) {
                        // throw { error }
                    // }
                    return (
                        <SearchPage
                            loading={!props}
                            articles={!props ? [] :
                            props.articles
                                .filter(a => {
                                    if (this.state.cityFilter && this.state.categoryFilter) {
                                        return true
                                    }
                                    if (this.state.cityFilter) {
                                        return (a.city != null)
                                    }
                                    if (this.state.categoryFilter) {
                                        return (a.category != null)
                                    }

                                    return false
                                })
                                .map(a => {
                                const group = a.city || a.category
                                return {
                                    ...a,
                                    link: routeResolver.article.get(group && group.slug, a.slug),
                                }
                            })}
                            searchTerm={this.state.searchTerm}
                            orderByRelevance={this.state.orderByRelevance}
                            onOrderByRelevance={() => this.setState({ orderByRelevance: true, orderByLatest: false })}
                            orderByLatest={this.state.orderByLatest}
                            onOrderByLatest={() => this.setState({ orderByRelevance: false, orderByLatest: true })}
                            cityFilter={this.state.cityFilter}
                            onCityFilter={() => this.setState({ cityFilter: !this.state.cityFilter })}
                            categoryFilter={this.state.categoryFilter}
                            onCategoryFilter={() => this.setState({ categoryFilter: !this.state.categoryFilter })}
                        />
                    )
                }}
            />
        )
    }
}

export default SearchContainer
